import { render } from "./preloader-sheet.vue?vue&type=template&id=7cbd024d"
import script from "./preloader-sheet.vue?vue&type=script&lang=js"
export * from "./preloader-sheet.vue?vue&type=script&lang=js"
script.render = render

export default script